module.exports = __webpack_public_path__ + "static/media/medio_camion.26b353c3.svg";